// https://vuex.vuejs.org/en/getters.html
import Cookies from 'js-cookie'
import { Ability } from '@casl/ability'

const abilityObj = new Ability([
  { action: ['read'], subject: ['all'] },
]);

export default {
  token: state => state.user.token,
  name: state => state.user.name,
  role: state => state.user.role,
  user: state => {
    return state.user.name + ' ' + state.user.surname
  },
  userObj: state => state.user,
  loading: state => state.app.loading,
  protocolDialog: state => state.app.protocol_dialog,
  protocolItem: state => state.app.protocol_item,
  siteDialog: state => state.app.site_dialog,
  siteItem: state => state.app.site_item,
  protocolSiteDialog: state => state.app.protocol_site_dialog,
  protocolSiteItem: state => state.app.protocol_site_item,
  treatmentDialog: state => state.app.treatment_dialog,
  treatmentItem: state => state.app.treatment_item,
  externalUserDialog: state => state.app.external_user_dialog,
  externalUserItem: state => state.app.external_user_item,
  adverseEventDialog: state => state.app.adverse_event_dialog,
  adverseEventMandatoryDialog: state => state.app.adverse_event_mandatory_dialog,
  adverseEventItem: state => state.app.adverse_event_item,
  pregnancyDialog: state => state.app.pregnancy_dialog,
  pregnancyItem: state => state.app.pregnancy_item,
  sponsors: state => { 
    return state.app.sponsors
  },
  sponsor_id: state => { 
    return state.app.sponsor_id ? 
      state.app.sponsor_id : 
      parseInt(Cookies.get('choosed_sponsor'));
  },
  protocols: state => state.app.protocols,
  sites: state => state.app.sites,
  treatments: state => state.app.treatments,
  external_users: state => state.app.external_users,
  snackbar: state => state.app.snackbar,
  sponsorsDisabled: state => state.app.sponsorsDisabled,
  ability: state => {
    return abilityObj;
  },
  changePass: state => state.app.changePass,
}
